import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TemplateMaisInformacoes } from 'src/app/utils/template-mais-informacoes';
import { MDialogComponent } from '../m-dialog/m-dialog.component';
import { ModalSidebarService } from '../modal-sidebar/modal-sidebar.service';

@Component({
  selector: 'app-footer-lgpd',
  templateUrl: './footer-lgpd.component.html',
  styleUrls: ['./footer-lgpd.component.scss']
})
export class FooterLgpdComponent implements OnInit {
  info: any;
  constructor(
    public modalSidebar: ModalSidebarService,
    public dialog: MatDialog
    ) { }

  ngOnInit(): void {
  }

  showModal() {
     this.info = {
      title: '',
      description: TemplateMaisInformacoes.obterTemplateMaisInformacoes()
    }

    this.modalSidebar.setModalData(this.info, true);
  }

}
